import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';

import { FilterValues, useProductsStore } from './products.store';
import { useThresholdsStore } from './thresholds.store';
import { useWallStructuresStore } from './wallStructures.store';

/** */
export const useMainStore = defineStore('main', {
  state: () => {
    return {
      /** */
      isAppReady: false,
      /** */
      paginationPage: 1,
      steps: reactive([
        { id: 'home', to: '/', completed: false },
        { id: 'select', to: '/select', completed: false },
        { id: 'printOut', to: '/print_out', completed: false }
      ]),
      activeStepId: ref('home'),
    };
  },
  getters: {
    currentStep: (state) => {
      let index = 0;
      const step = state.steps.find((step, i) => {
        if (step.id === state.activeStepId)
          return index = i;
      }) || state.steps[0];
      return { ...step, index };
    }
  },
  actions: {
    /** */
    async setData () {
      console.time('Creating data');
      this.isAppReady = false;

      await Promise.all([
        useProductsStore().fetchProducts(),
        useThresholdsStore().fetchThresholds(),
        useWallStructuresStore().fetchWallStructures(),
      ]).then(() => {
        this.isAppReady = true;
        console.timeEnd('Creating data');
      }).catch((err) => {
        console.timeEnd('Creating data');
        throw Error(err);
      });
    },
    async setNextStep () {
      if (this.currentStep.index >= this.steps.length - 1) {
        this.activeStepId = this.steps[this.steps.length - 1].id;
        return;
      }
      this.activeStepId = this.steps[this.currentStep.index + 1].id;
    },
    async setPreviousStep () {
      if (this.currentStep.index > 0) {
        this.activeStepId = this.steps[this.currentStep.index - 1].id;
        return;
      }
      this.activeStepId = this.steps[0].id;
    },
    async completeStep (isComplete: boolean) {
      const step = this.steps[this.currentStep.index];
      if (step) {
        step.completed = isComplete;
      }
    },
    /** */
    resetState () {
      const products = useProductsStore();
      const wallStructure = useWallStructuresStore();
      this.activeStepId = 'home';

      Object.keys(products.filterValues).forEach((key) => {
        products.filterValues[key as keyof FilterValues] = '_none';
      });

      wallStructure.selectedThickness = 0;
      wallStructure.selectedWallStructure = null;
      products.selectedProduct = null;
    }
  }
});
